import { render, staticRenderFns } from "./AppShopButton.vue?vue&type=template&id=fa1d3602&"
import script from "./AppShopButton.vue?vue&type=script&lang=js&"
export * from "./AppShopButton.vue?vue&type=script&lang=js&"
import style0 from "./AppShopButton.vue?vue&type=style&index=0&id=fa1d3602&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
